import { NgModule } from '@angular/core';
import { InternalServerErrorPage } from './internal-server-error/internal-server-error.page';
import { PageForbidden } from './page-forbidden/page-forbidden.page';
import { PageNotFoundPage } from './page-not-found/page-not-found.page';
import { RouteService } from '../../routing/services/route.service';
import { SupportModule } from '../../support/support.module';

@NgModule({
    imports: [SupportModule],
    exports: [],
    declarations: [InternalServerErrorPage, PageForbidden, PageNotFoundPage],
    entryComponents: [InternalServerErrorPage, PageForbidden, PageNotFoundPage],
    providers: [],
})
export class ErrorPagesModule {

    public constructor(routes: RouteService) {
0
        routes.add('500', InternalServerErrorPage, '500', {layout: 'error'});
        routes.add('404', PageNotFoundPage, '404', {layout: 'error'});
        routes.add('403', PageForbidden, '403', {layout: 'error'});
        routes.add('**', PageNotFoundPage, 'exception', {layout: 'error'});

        routes.apply();

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/errors/error-pages.module.ts